import React from "react";
import { Box } from "@mui/material";
import { SxProps } from "@mui/system";

// A picture from the analysis pipeline. The timeline shows it at the width of its column, which is
// far smaller than it was drawn; clicking opens the file itself in a new tab, at full resolution.
// The magnifier cursor is what says so.
const ZoomableImage = ({
  src,
  width,
  sx,
}: {
  src: string;
  width?: number | string;
  sx?: SxProps;
}) => (
  <Box
    component="img"
    alt=""
    src={src}
    onClick={() => window.open(src, "_blank", "noopener")}
    sx={{ cursor: "zoom-in", width, ...sx }}
  />
);

export default ZoomableImage;
